// @flow

import styled from '@emotion/styled';
import React from 'react';

import usePartnerPermissions from './hooks/usePartnerPermissions';

type Props = {
  appManageLink: string,
  appShortLink: string,
  mpacBaseUrl: string,
  partnerId: string,
};

const AdminHeaderLinksContainer = styled.ul`
  padding: 0;
  margin: 0 0 12px;
`;

const AdminHeaderLinksItem = styled.li`
  display: inline;
  & + &::before {
    content: ' • ';
  }
`;

const AdminHeaderLinks = (props: Props) => {
  const { permissions } = usePartnerPermissions(props.mpacBaseUrl, props.partnerId);
  return (
    (permissions?.canManageAppDetails ?? false) && (
      <AdminHeaderLinksContainer>
        <AdminHeaderLinksItem>
          <a href={props.appManageLink}>Manage app</a>
        </AdminHeaderLinksItem>
        <AdminHeaderLinksItem>
          <a href={props.appShortLink}>Short link</a>
        </AdminHeaderLinksItem>
      </AdminHeaderLinksContainer>
    )
  );
};

export default AdminHeaderLinks;
